import { combineReducers } from 'redux';
import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

const initialState = Immutable({
  saving: false,
});

export function setInterests(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_USER_INTERESTS.START:
      return state.merge({
        saving: true,
      });

    case actionTypes.SET_USER_INTERESTS.SUCCESS:
    case actionTypes.SET_USER_INTERESTS.FAILURE:
      return state.merge({
        saving: false,
      });
    default:
      return state;
  }
}

export default combineReducers({
  setInterests,
});
